export type Province = {
  slug: string;
  name: string;
  sigla: string;
  regioneSlug: string;
  regioneName: string;
};

// Replace the content below with the actual JSON content from data/province.json.
// Keep the same fields. This avoids JSON import pitfalls in client bundles.
export const PROVINCES: Province[] = [
  {
    "slug": "agrigento",
    "name": "Agrigento",
    "sigla": "AG",
    "regioneSlug": "sicilia",
    "regioneName": "Sicilia"
  },
  {
    "slug": "alessandria",
    "name": "Alessandria",
    "sigla": "AL",
    "regioneSlug": "piemonte",
    "regioneName": "Piemonte"
  },
  {
    "slug": "ancona",
    "name": "Ancona",
    "sigla": "AN",
    "regioneSlug": "marche",
    "regioneName": "Marche"
  },
  {
    "slug": "aosta",
    "name": "Aosta",
    "sigla": "AO",
    "regioneSlug": "valle-d-aosta",
    "regioneName": "Valle d'Aosta"
  },
  {
    "slug": "arezzo",
    "name": "Arezzo",
    "sigla": "AR",
    "regioneSlug": "toscana",
    "regioneName": "Toscana"
  },
  {
    "slug": "ascoli-piceno",
    "name": "Ascoli Piceno",
    "sigla": "AP",
    "regioneSlug": "marche",
    "regioneName": "Marche"
  },
  {
    "slug": "asti",
    "name": "Asti",
    "sigla": "AT",
    "regioneSlug": "piemonte",
    "regioneName": "Piemonte"
  },
  {
    "slug": "avellino",
    "name": "Avellino",
    "sigla": "AV",
    "regioneSlug": "campania",
    "regioneName": "Campania"
  },
  {
    "slug": "bari",
    "name": "Bari",
    "sigla": "BA",
    "regioneSlug": "puglia",
    "regioneName": "Puglia"
  },
  {
    "slug": "barletta-andria-trani",
    "name": "Barletta-Andria-Trani",
    "sigla": "BT",
    "regioneSlug": "puglia",
    "regioneName": "Puglia"
  },
  {
    "slug": "belluno",
    "name": "Belluno",
    "sigla": "BL",
    "regioneSlug": "veneto",
    "regioneName": "Veneto"
  },
  {
    "slug": "benevento",
    "name": "Benevento",
    "sigla": "BN",
    "regioneSlug": "campania",
    "regioneName": "Campania"
  },
  {
    "slug": "bergamo",
    "name": "Bergamo",
    "sigla": "BG",
    "regioneSlug": "lombardia",
    "regioneName": "Lombardia"
  },
  {
    "slug": "biella",
    "name": "Biella",
    "sigla": "BI",
    "regioneSlug": "piemonte",
    "regioneName": "Piemonte"
  },
  {
    "slug": "bologna",
    "name": "Bologna",
    "sigla": "BO",
    "regioneSlug": "emilia-romagna",
    "regioneName": "Emilia-Romagna"
  },
  {
    "slug": "bolzano",
    "name": "Bolzano",
    "sigla": "BZ",
    "regioneSlug": "trentino-alto-adige-sudtirol",
    "regioneName": "Trentino-Alto Adige/Südtirol"
  },
  {
    "slug": "brescia",
    "name": "Brescia",
    "sigla": "BS",
    "regioneSlug": "lombardia",
    "regioneName": "Lombardia"
  },
  {
    "slug": "brindisi",
    "name": "Brindisi",
    "sigla": "BR",
    "regioneSlug": "puglia",
    "regioneName": "Puglia"
  },
  {
    "slug": "cagliari",
    "name": "Cagliari",
    "sigla": "CA",
    "regioneSlug": "sardegna",
    "regioneName": "Sardegna"
  },
  {
    "slug": "caltanissetta",
    "name": "Caltanissetta",
    "sigla": "CL",
    "regioneSlug": "sicilia",
    "regioneName": "Sicilia"
  },
  {
    "slug": "campobasso",
    "name": "Campobasso",
    "sigla": "CB",
    "regioneSlug": "molise",
    "regioneName": "Molise"
  },
  {
    "slug": "caserta",
    "name": "Caserta",
    "sigla": "CE",
    "regioneSlug": "campania",
    "regioneName": "Campania"
  },
  {
    "slug": "catania",
    "name": "Catania",
    "sigla": "CT",
    "regioneSlug": "sicilia",
    "regioneName": "Sicilia"
  },
  {
    "slug": "catanzaro",
    "name": "Catanzaro",
    "sigla": "CZ",
    "regioneSlug": "calabria",
    "regioneName": "Calabria"
  },
  {
    "slug": "chieti",
    "name": "Chieti",
    "sigla": "CH",
    "regioneSlug": "abruzzo",
    "regioneName": "Abruzzo"
  },
  {
    "slug": "como",
    "name": "Como",
    "sigla": "CO",
    "regioneSlug": "lombardia",
    "regioneName": "Lombardia"
  },
  {
    "slug": "cosenza",
    "name": "Cosenza",
    "sigla": "CS",
    "regioneSlug": "calabria",
    "regioneName": "Calabria"
  },
  {
    "slug": "cremona",
    "name": "Cremona",
    "sigla": "CR",
    "regioneSlug": "lombardia",
    "regioneName": "Lombardia"
  },
  {
    "slug": "crotone",
    "name": "Crotone",
    "sigla": "KR",
    "regioneSlug": "calabria",
    "regioneName": "Calabria"
  },
  {
    "slug": "cuneo",
    "name": "Cuneo",
    "sigla": "CN",
    "regioneSlug": "piemonte",
    "regioneName": "Piemonte"
  },
  {
    "slug": "enna",
    "name": "Enna",
    "sigla": "EN",
    "regioneSlug": "sicilia",
    "regioneName": "Sicilia"
  },
  {
    "slug": "fermo",
    "name": "Fermo",
    "sigla": "FM",
    "regioneSlug": "marche",
    "regioneName": "Marche"
  },
  {
    "slug": "ferrara",
    "name": "Ferrara",
    "sigla": "FE",
    "regioneSlug": "emilia-romagna",
    "regioneName": "Emilia-Romagna"
  },
  {
    "slug": "firenze",
    "name": "Firenze",
    "sigla": "FI",
    "regioneSlug": "toscana",
    "regioneName": "Toscana"
  },
  {
    "slug": "foggia",
    "name": "Foggia",
    "sigla": "FG",
    "regioneSlug": "puglia",
    "regioneName": "Puglia"
  },
  {
    "slug": "forli-cesena",
    "name": "Forlì-Cesena",
    "sigla": "FC",
    "regioneSlug": "emilia-romagna",
    "regioneName": "Emilia-Romagna"
  },
  {
    "slug": "frosinone",
    "name": "Frosinone",
    "sigla": "FR",
    "regioneSlug": "lazio",
    "regioneName": "Lazio"
  },
  {
    "slug": "genova",
    "name": "Genova",
    "sigla": "GE",
    "regioneSlug": "liguria",
    "regioneName": "Liguria"
  },
  {
    "slug": "gorizia",
    "name": "Gorizia",
    "sigla": "GO",
    "regioneSlug": "friuli-venezia-giulia",
    "regioneName": "Friuli-Venezia Giulia"
  },
  {
    "slug": "grosseto",
    "name": "Grosseto",
    "sigla": "GR",
    "regioneSlug": "toscana",
    "regioneName": "Toscana"
  },
  {
    "slug": "imperia",
    "name": "Imperia",
    "sigla": "IM",
    "regioneSlug": "liguria",
    "regioneName": "Liguria"
  },
  {
    "slug": "isernia",
    "name": "Isernia",
    "sigla": "IS",
    "regioneSlug": "molise",
    "regioneName": "Molise"
  },
  {
    "slug": "la-spezia",
    "name": "La Spezia",
    "sigla": "SP",
    "regioneSlug": "liguria",
    "regioneName": "Liguria"
  },
  {
    "slug": "laquila",
    "name": "L'Aquila",
    "sigla": "AQ",
    "regioneSlug": "abruzzo",
    "regioneName": "Abruzzo"
  },
  {
    "slug": "latina",
    "name": "Latina",
    "sigla": "LT",
    "regioneSlug": "lazio",
    "regioneName": "Lazio"
  },
  {
    "slug": "lecce",
    "name": "Lecce",
    "sigla": "LE",
    "regioneSlug": "puglia",
    "regioneName": "Puglia"
  },
  {
    "slug": "lecco",
    "name": "Lecco",
    "sigla": "LC",
    "regioneSlug": "lombardia",
    "regioneName": "Lombardia"
  },
  {
    "slug": "livorno",
    "name": "Livorno",
    "sigla": "LI",
    "regioneSlug": "toscana",
    "regioneName": "Toscana"
  },
  {
    "slug": "lodi",
    "name": "Lodi",
    "sigla": "LO",
    "regioneSlug": "lombardia",
    "regioneName": "Lombardia"
  },
  {
    "slug": "lucca",
    "name": "Lucca",
    "sigla": "LU",
    "regioneSlug": "toscana",
    "regioneName": "Toscana"
  },
  {
    "slug": "macerata",
    "name": "Macerata",
    "sigla": "MC",
    "regioneSlug": "marche",
    "regioneName": "Marche"
  },
  {
    "slug": "mantova",
    "name": "Mantova",
    "sigla": "MN",
    "regioneSlug": "lombardia",
    "regioneName": "Lombardia"
  },
  {
    "slug": "massa-carrara",
    "name": "Massa-Carrara",
    "sigla": "MS",
    "regioneSlug": "toscana",
    "regioneName": "Toscana"
  },
  {
    "slug": "matera",
    "name": "Matera",
    "sigla": "MT",
    "regioneSlug": "basilicata",
    "regioneName": "Basilicata"
  },
  {
    "slug": "messina",
    "name": "Messina",
    "sigla": "ME",
    "regioneSlug": "sicilia",
    "regioneName": "Sicilia"
  },
  {
    "slug": "milano",
    "name": "Milano",
    "sigla": "MI",
    "regioneSlug": "lombardia",
    "regioneName": "Lombardia"
  },
  {
    "slug": "modena",
    "name": "Modena",
    "sigla": "MO",
    "regioneSlug": "emilia-romagna",
    "regioneName": "Emilia-Romagna"
  },
  {
    "slug": "monza-e-della-brianza",
    "name": "Monza e della Brianza",
    "sigla": "MB",
    "regioneSlug": "lombardia",
    "regioneName": "Lombardia"
  },
  {
    "slug": "napoli",
    "name": "Napoli",
    "sigla": "NA",
    "regioneSlug": "campania",
    "regioneName": "Campania"
  },
  {
    "slug": "novara",
    "name": "Novara",
    "sigla": "NO",
    "regioneSlug": "piemonte",
    "regioneName": "Piemonte"
  },
  {
    "slug": "nuoro",
    "name": "Nuoro",
    "sigla": "NU",
    "regioneSlug": "sardegna",
    "regioneName": "Sardegna"
  },
  {
    "slug": "oristano",
    "name": "Oristano",
    "sigla": "OR",
    "regioneSlug": "sardegna",
    "regioneName": "Sardegna"
  },
  {
    "slug": "padova",
    "name": "Padova",
    "sigla": "PD",
    "regioneSlug": "veneto",
    "regioneName": "Veneto"
  },
  {
    "slug": "palermo",
    "name": "Palermo",
    "sigla": "PA",
    "regioneSlug": "sicilia",
    "regioneName": "Sicilia"
  },
  {
    "slug": "parma",
    "name": "Parma",
    "sigla": "PR",
    "regioneSlug": "emilia-romagna",
    "regioneName": "Emilia-Romagna"
  },
  {
    "slug": "pavia",
    "name": "Pavia",
    "sigla": "PV",
    "regioneSlug": "lombardia",
    "regioneName": "Lombardia"
  },
  {
    "slug": "perugia",
    "name": "Perugia",
    "sigla": "PG",
    "regioneSlug": "umbria",
    "regioneName": "Umbria"
  },
  {
    "slug": "pesaro-e-urbino",
    "name": "Pesaro e Urbino",
    "sigla": "PU",
    "regioneSlug": "marche",
    "regioneName": "Marche"
  },
  {
    "slug": "pescara",
    "name": "Pescara",
    "sigla": "PE",
    "regioneSlug": "abruzzo",
    "regioneName": "Abruzzo"
  },
  {
    "slug": "piacenza",
    "name": "Piacenza",
    "sigla": "PC",
    "regioneSlug": "emilia-romagna",
    "regioneName": "Emilia-Romagna"
  },
  {
    "slug": "pisa",
    "name": "Pisa",
    "sigla": "PI",
    "regioneSlug": "toscana",
    "regioneName": "Toscana"
  },
  {
    "slug": "pistoia",
    "name": "Pistoia",
    "sigla": "PT",
    "regioneSlug": "toscana",
    "regioneName": "Toscana"
  },
  {
    "slug": "pordenone",
    "name": "Pordenone",
    "sigla": "PN",
    "regioneSlug": "friuli-venezia-giulia",
    "regioneName": "Friuli-Venezia Giulia"
  },
  {
    "slug": "potenza",
    "name": "Potenza",
    "sigla": "PZ",
    "regioneSlug": "basilicata",
    "regioneName": "Basilicata"
  },
  {
    "slug": "prato",
    "name": "Prato",
    "sigla": "PO",
    "regioneSlug": "toscana",
    "regioneName": "Toscana"
  },
  {
    "slug": "ragusa",
    "name": "Ragusa",
    "sigla": "RG",
    "regioneSlug": "sicilia",
    "regioneName": "Sicilia"
  },
  {
    "slug": "ravenna",
    "name": "Ravenna",
    "sigla": "RA",
    "regioneSlug": "emilia-romagna",
    "regioneName": "Emilia-Romagna"
  },
  {
    "slug": "reggio-calabria",
    "name": "Reggio Calabria",
    "sigla": "RC",
    "regioneSlug": "calabria",
    "regioneName": "Calabria"
  },
  {
    "slug": "reggio-emilia",
    "name": "Reggio Emilia",
    "sigla": "RE",
    "regioneSlug": "emilia-romagna",
    "regioneName": "Emilia-Romagna"
  },
  {
    "slug": "rieti",
    "name": "Rieti",
    "sigla": "RI",
    "regioneSlug": "lazio",
    "regioneName": "Lazio"
  },
  {
    "slug": "rimini",
    "name": "Rimini",
    "sigla": "RN",
    "regioneSlug": "emilia-romagna",
    "regioneName": "Emilia-Romagna"
  },
  {
    "slug": "roma",
    "name": "Roma",
    "sigla": "RM",
    "regioneSlug": "lazio",
    "regioneName": "Lazio"
  },
  {
    "slug": "rovigo",
    "name": "Rovigo",
    "sigla": "RO",
    "regioneSlug": "veneto",
    "regioneName": "Veneto"
  },
  {
    "slug": "salerno",
    "name": "Salerno",
    "sigla": "SA",
    "regioneSlug": "campania",
    "regioneName": "Campania"
  },
  {
    "slug": "sassari",
    "name": "Sassari",
    "sigla": "SS",
    "regioneSlug": "sardegna",
    "regioneName": "Sardegna"
  },
  {
    "slug": "savona",
    "name": "Savona",
    "sigla": "SV",
    "regioneSlug": "liguria",
    "regioneName": "Liguria"
  },
  {
    "slug": "siena",
    "name": "Siena",
    "sigla": "SI",
    "regioneSlug": "toscana",
    "regioneName": "Toscana"
  },
  {
    "slug": "siracusa",
    "name": "Siracusa",
    "sigla": "SR",
    "regioneSlug": "sicilia",
    "regioneName": "Sicilia"
  },
  {
    "slug": "sondrio",
    "name": "Sondrio",
    "sigla": "SO",
    "regioneSlug": "lombardia",
    "regioneName": "Lombardia"
  },
  {
    "slug": "sud-sardegna",
    "name": "Sud Sardegna",
    "sigla": "SU",
    "regioneSlug": "sardegna",
    "regioneName": "Sardegna"
  },
  {
    "slug": "taranto",
    "name": "Taranto",
    "sigla": "TA",
    "regioneSlug": "puglia",
    "regioneName": "Puglia"
  },
  {
    "slug": "teramo",
    "name": "Teramo",
    "sigla": "TE",
    "regioneSlug": "abruzzo",
    "regioneName": "Abruzzo"
  },
  {
    "slug": "terni",
    "name": "Terni",
    "sigla": "TR",
    "regioneSlug": "umbria",
    "regioneName": "Umbria"
  },
  {
    "slug": "torino",
    "name": "Torino",
    "sigla": "TO",
    "regioneSlug": "piemonte",
    "regioneName": "Piemonte"
  },
  {
    "slug": "trapani",
    "name": "Trapani",
    "sigla": "TP",
    "regioneSlug": "sicilia",
    "regioneName": "Sicilia"
  },
  {
    "slug": "trento",
    "name": "Trento",
    "sigla": "TN",
    "regioneSlug": "trentino-alto-adige-sudtirol",
    "regioneName": "Trentino-Alto Adige/Südtirol"
  },
  {
    "slug": "treviso",
    "name": "Treviso",
    "sigla": "TV",
    "regioneSlug": "veneto",
    "regioneName": "Veneto"
  },
  {
    "slug": "trieste",
    "name": "Trieste",
    "sigla": "TS",
    "regioneSlug": "friuli-venezia-giulia",
    "regioneName": "Friuli-Venezia Giulia"
  },
  {
    "slug": "udine",
    "name": "Udine",
    "sigla": "UD",
    "regioneSlug": "friuli-venezia-giulia",
    "regioneName": "Friuli-Venezia Giulia"
  },
  {
    "slug": "varese",
    "name": "Varese",
    "sigla": "VA",
    "regioneSlug": "lombardia",
    "regioneName": "Lombardia"
  },
  {
    "slug": "venezia",
    "name": "Venezia",
    "sigla": "VE",
    "regioneSlug": "veneto",
    "regioneName": "Veneto"
  },
  {
    "slug": "verbano-cusio-ossola",
    "name": "Verbano-Cusio-Ossola",
    "sigla": "VB",
    "regioneSlug": "piemonte",
    "regioneName": "Piemonte"
  },
  {
    "slug": "vercelli",
    "name": "Vercelli",
    "sigla": "VC",
    "regioneSlug": "piemonte",
    "regioneName": "Piemonte"
  },
  {
    "slug": "verona",
    "name": "Verona",
    "sigla": "VR",
    "regioneSlug": "veneto",
    "regioneName": "Veneto"
  },
  {
    "slug": "vibo-valentia",
    "name": "Vibo Valentia",
    "sigla": "VV",
    "regioneSlug": "calabria",
    "regioneName": "Calabria"
  },
  {
    "slug": "vicenza",
    "name": "Vicenza",
    "sigla": "VI",
    "regioneSlug": "veneto",
    "regioneName": "Veneto"
  },
  {
    "slug": "viterbo",
    "name": "Viterbo",
    "sigla": "VT",
    "regioneSlug": "lazio",
    "regioneName": "Lazio"
  }
];







